import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={15.431}
    height="6.8mm"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 26012 43324"
    {...props}
  >
    <path
      d="M22230 13807c-1868 1442-2984 3744-2984 6157l1 6824c0 1623-794 3120-2129 4031H8891c-1335-911-2129-2408-2129-4031v-6825c0-2413-1115-4714-2985-6156-1671-1291-2654-2895-2811-4562h24074c-154 1668-1139 3272-2810 4562zM9221 33166v-1405h7567v1405H9221zm7567 2349H9221v-1407h7567v1407zm0 2347H9221v-1406h7567v1406zm-1511 2347h-4545c-798 0-1452-621-1507-1405h7558c-56 784-711 1405-1506 1405zm-1107 2173h-2333l-438-1231h3209l-438 1231zM13004 942c6409 0 11662 3261 12039 7361H966C1340 4203 6595 942 13004 942zm13004 7814C25994 3927 20167 0 13004 0 5840 0 8 3930 0 8763c5 2150 1140 4198 3202 5789 1639 1265 2619 3288 2619 5411v6825c0 1902 913 3658 2458 4749v1629h-320c-259 0-471 212-471 471 0 261 212 471 471 471h320v1407h-320c-259 0-471 210-471 470s212 471 471 471h320v1406h-320c-259 0-471 211-471 471s212 471 471 471h325c51 1188 948 2158 2107 2320l671 1886c66 188 242 314 442 314h3001c197 0 376-126 442-313l671-1887c1156-163 2056-1132 2107-2320h323c261 0 470-211 470-471 1-260-209-471-470-471h-318v-1406h318c261 0 470-211 470-471 1-260-209-470-470-470h-318v-1407h318c261 0 470-210 470-471 1-260-209-471-470-471h-318v-1629c1542-1091 2458-2847 2458-4749v-6824c0-2124 977-4146 2618-5411 2317-1787 3268-4044 3202-5797z"
      style={{
        fill: "#2b2a29",
      }}
      className="fill"
    />
  </svg>
)
export default SvgComponent
